import { cloneDeep } from 'lodash-es';
import moment from 'moment';

import * as SearchActions from '../state/search/search.action';

import template from './equipment.detail.edit.controller.html';

// Constants
const EVENT_TRACKING_NAME = 'assetEdit';
const EVENT_TRACKING_ACTIONS = {
  addAttribute: 'addAttribute',
  removeAttribute: 'removeAttribute',
  cancelClicked: 'cancelClicked',
  saveClicked: 'saveClicked',
};

class EquipmentDetailEditController {
  constructor(
    $ngRedux,
    $scope,
    $state,
    $filter,
    $stateParams,
    $timeout,
    EquipmentService,
    gettextCatalog,
  ) {
    'ngInject';

    this.$scope = $scope;
    this.$state = $state;
    this.$filter = $filter;
    this.$stateParams = $stateParams;
    this.timeout = $timeout;
    this.EquipmentService = EquipmentService;
    this.gettextCatalog = gettextCatalog;
    this.store = $ngRedux;

    this.tags = [];
    this.isLoading = true;
    this.selectedTags = [];
    this.parsedAttrs = {};
    this.parsedTags = [];
    this.values = {};
    this.focus = {};
    this.opened = {};
    this.datetimedate = {};
    this.datetimeBounds = {};
    this.protectedAttrs = {};
    this.format = 'yyyy/MM/dd';
    this.dateFormatMoment = 'YYYY/MM/DD';

    this.mapStateToThis = this.mapStateToThis.bind(this);
    this.initDataNeeded = true;
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis, SearchActions)(this);
    this.refreshEdit();
  }

  mapStateToThis(state) {
    const {
      user: { dateFormat = 'yyyy/MM/dd' },
      attributes,
    } = state;

    const { secured = {}, isSecuredLoaded } = attributes;
    // when secured.readonly loaded after init
    // call refreshEdit() for one time only
    if (isSecuredLoaded && this.initDataNeeded) {
      this.refreshEdit();
    }

    return {
      format: dateFormat.toLowerCase().replace(/m/g, 'M'),
      dateFormatMoment: dateFormat,
      dateTimeformat: `${dateFormat} h:mm:ss a`,
      readonlyAttributes: secured.readonly, // normalized to lowercase keys
      readonlyAttributesLoaded: isSecuredLoaded,
    };
  }

  $onDestroy() {
    this.unsubscribe();
  }

  addToDataLayer(data) {
    window.dataLayer.push({
      event: EVENT_TRACKING_NAME,
      data: { ...data },
    });
  }

  refreshEdit() {
    this.isLoading = true;

    // if readonlyAttributesLoaded has not loaded will return now, another call will trigger by mapStateToThis
    if (!this.readonlyAttributesLoaded) return;

    this.initDataNeeded = false;
    this.EquipmentService.getEquipment(this.$stateParams.equipmentId)
      .then(
        (response) => {
          // Qucik fix...
          this.equipmentData = response.data.data.attributes;
          this.equipmentData.id = response.data.data.id;
          this.equipmentData.data = {};
          this.equipmentData.data.attributes = {
            name: this.equipmentData.name,
          };
          this.$scope.$emit('$viewContentLoaded'); // breadcrumb fix;
          return this.EquipmentService.getAllTags().then(null, (error) => {
            let errorMsg = this.gettextCatalog.getString(
              'An error occurred while retrieving attribute information',
            );
            if (error.data || error.status) {
              if (error.data.message) {
                errorMsg = `${
                  error.data.message
                } ${error.status.toString()} - ${error.statusText.toString()}`;
              } else {
                errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
              }
            } else {
              errorMsg += this.gettextCatalog.getString('. Please try again later.');
            }
            this.onLoadErrorFlag = true;
            this.onLoadErrorText = errorMsg;
            this.isLoading = false;
          });
        },
        function (error) {
          let errorMsg = this.gettextCatalog.getString(
            'An error occurred while retrieving asset information',
          );
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg = `${
                error.data.message
              } ${error.status.toString()} - ${error.statusText.toString()}`;
            } else {
              errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
            }
          } else {
            errorMsg += this.gettextCatalog.getString('. Please try again later.');
          }
          this.onLoadErrorFlag = true;
          this.onLoadErrorText = errorMsg;
          this.isLoading = false;
        },
      )
      .then((response) => {
        this.tags = response.data.data;
        for (let i = 0; i < this.tags.length; i++) {
          if (this.tags[i].dataType === 'Datetime') {
            if (this.tags[i].range.min) {
              this.tags[i].range.min = moment(this.tags[i].range.min);
            }
            if (this.tags[i].range.max) {
              this.tags[i].range.max = moment(this.tags[i].range.max);
            }
          }
        }

        if (this.equipmentData) {
          this.parseTags();
        }

        this.availableTags = cloneDeep(this.tags);
        this.selectedTags = [];
        this.values = {};

        for (let i = 0; i < this.parsedTags.length; i++) {
          const parsedTag = this.parsedTags[i];
          const parsedTagIndex = parsedTag.index;
          const parsedTagValue = parsedTag.value;
          const parsedTagId = parsedTag.id;
          const availableTag = this.availableTags[parsedTagIndex];
          // appandtag set this.values.
          this.appendTag(availableTag, false);

          const parsedTagValueRecord = this.values[parsedTagId];
          const { dataType } = availableTag;

          switch (dataType) {
            case 'Integer': {
              parsedTagValueRecord.value = parseInt(parsedTagValue);
              break;
            }

            case 'Decimal': {
              parsedTagValueRecord.value = parseFloat(parsedTagValue);
              break;
            }

            case 'Text': {
              parsedTagValueRecord.value = parsedTagValue;
              break;
            }

            case 'Date': {
              parsedTagValueRecord.value = moment(parsedTagValue).toDate();
              break;
            }

            case 'Datetime': {
              const parsedDate = moment(parsedTagValue).toDate();
              parsedTagValueRecord.value = parsedDate;
              this.datetimedate[parsedTagId] = parsedDate;
              break;
            }

            default:
              parsedTagValueRecord.value = parsedTag.value;
          }
          // re assign handled record.
          this.values[parsedTagId] = parsedTagValueRecord;
        }

        this.isLoading = false;
      });
  }

  toTitleCase(input) {
    input = input || '';
    return input.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  parseTags() {
    this.parsedTags = [];
    this.parsedAttrs = {};
    for (const key in this.equipmentData.attrs) {
      const normalizedKey = key != null ? key.toLowerCase() : '';
      if (this.readonlyAttributes.indexOf(normalizedKey) !== -1) {
        // readonly attributes are hidden completely from this UI
        this.protectedAttrs[key] = this.equipmentData.attrs[key];
        continue;
      } else if (key.startsWith('onei3:')) {
        this.protectedAttrs[key] = this.equipmentData.attrs[key];
        continue;
      }

      let found = false;
      for (let j = 0; j < this.tags.length; j++) {
        const tag = this.tags[j];
        if (normalizedKey === tag.key.toLowerCase()) {
          this.parsedTags.push({
            key: tag.key,
            value:
              tag.dataType === 'Datetime'
                ? moment(this.equipmentData.attrs[key])
                : this.equipmentData.attrs[key],
            index: j,
            dataType: tag.dataType,
            id: tag.id,
          });
          found = true;
          break;
        }
      }
      if (!found) {
        this.parsedAttrs[key] = this.equipmentData.attrs[key];
      }
    }
  }

  appendTag(tag, isNew) {
    this.selectedTags.push(tag);
    this.values[tag.id] = {
      tag: tag.id,
    };
    if (tag.dataType === 'Date' || tag.dataType === 'Datetime') {
      this.opened[tag.id] = false;
      if (tag.freeform) {
        this.values[tag.id].value = moment().toDate();
        if (tag.dataType === 'Datetime') {
          this.values[tag.id].value = moment().toDate();
          this.datetimedate[tag.id] = moment(this.values[tag.id].value).toDate();
          this.datetimeBounds[tag.id] = {};
        }
      } else {
        if (tag.range.min) {
          this.values[tag.id].value = moment(tag.range.min).toDate();
          if (tag.dataType === 'Datetime') {
            this.values[tag.id].value = moment(tag.range.min).toDate();
            this.datetimedate[tag.id] = moment(tag.range.min).toDate();
            this.values[tag.id].minValue = moment(tag.range.min).toDate();
            this.datetimeBounds[tag.id] = {};
          }
        }
        if (tag.range.max) {
          this.values[tag.id].value = moment(tag.range.max).toDate();
          if (tag.dataType === 'Datetime') {
            this.values[tag.id].value = moment(tag.range.max).toDate();
            this.datetimedate[tag.id] = moment(tag.range.max).toDate();
            this.values[tag.id].maxValue = moment(tag.range.max).toDate();
            this.datetimeBounds[tag.id] = {};
          }
        }
      }
    }
    tag.selected = true;
    this.newTag = undefined;
    this.focus[tag.id] = isNew;

    // Prevent from triggering at the start of the container.
    if (!this.isLoading) {
      this.addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.addAttribute,
      });
    }
  }

  removeTag(index) {
    const tag = this.selectedTags[index];
    tag.selected = false;
    if (this.equipmentData.attrs[tag.key]) {
      delete this.equipmentData.attrs[tag.key];
    }
    delete this.values[tag.id];
    delete this.focus[tag.id];
    this.selectedTags.splice(index, 1);
  }

  removeAttr(key) {
    delete this.parsedAttrs[key];
    // GTM-UPDATE -> GTM-UPDATED
    this.addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.removeAttribute,
    });
  }

  filterSelected(tag) {
    return !tag.selected;
  }

  roundInt(val) {
    return val ? Math.floor(val) : val;
  }

  open(index) {
    this.opened[index] = true;
  }

  datetimeValidCheck(id) {
    const valueRecord = this.values[id];
    const { value } = valueRecord;
    const temp = moment(this.datetimedate[id].getTime()).toDate();
    if (value) {
      temp.setHours(value.getHours());
      temp.setMinutes(value.getMinutes());
      temp.setSeconds(value.getSeconds());
    }
    if (
      (!valueRecord.minValue || temp >= valueRecord.minValue) &&
      (!valueRecord.maxValue || temp <= valueRecord.maxValue)
    ) {
      return true;
    }

    return false;
  }

  updateTimeBounds(id) {
    this.datetimeBounds[id].min = this.returnTimeBound('min', id);
    this.datetimeBounds[id].max = this.returnTimeBound('max', id);
  }

  returnTimeBound(key, id) {
    const valueRecord = this.values[id];
    switch (key) {
      case 'max':
        if (!this.datetimedate[id] || !valueRecord.maxValue) {
          return undefined;
        }
        if (this.datetimedate[id].toDateString() === valueRecord.maxValue.toDateString()) {
          const tempMax = moment(valueRecord.value.getTime()).toDate();
          if (valueRecord.maxValue) {
            tempMax.setHours(valueRecord.maxValue.getHours());
            tempMax.setMinutes(valueRecord.maxValue.getMinutes());
            tempMax.setSeconds(valueRecord.maxValue.getSeconds());
          }
          return tempMax;
        }
        return undefined;

      case 'min':
        if (!this.datetimedate[id] || !valueRecord.minValue) {
          return undefined;
        }
        if (this.datetimedate[id].toDateString() === valueRecord.minValue.toDateString()) {
          const tempMin = moment(valueRecord.value.getTime()).toDate();
          if (valueRecord.minValue) {
            tempMin.setHours(valueRecord.minValue.getHours());
            tempMin.setMinutes(valueRecord.minValue.getMinutes());
            tempMin.setSeconds(valueRecord.minValue.getSeconds());
          }
          return tempMin;
        }
        return undefined;
    }
  }

  checkAllDatetimes() {
    for (let i = 0; i < this.selectedTags.length; i++) {
      const selectedTag = this.selectedTags[i];
      if (selectedTag.dataType === 'Datetime' && !selectedTag.freeform) {
        if (!this.datetimeValidCheck(selectedTag.id)) {
          return false;
        }
      }
    }
    return true;
  }

  generateTooltip(tag) {
    let tip = '';
    switch (tag.dataType) {
      case 'Integer':
        tip = this.gettextCatalog.getString('Enter an integer ');
        if (tag.range.min) {
          if (!tag.range.max) {
            tip += this.gettextCatalog.getString('(minimum {{min}})', {
              min: tag.range.min,
            });
          } else {
            tip += this.gettextCatalog.getString('from {{min}} to ', {
              min: tag.range.min,
            });
          }
        }
        if (tag.range.max) {
          if (!tag.range.min) {
            tip += this.gettextCatalog.getString('(maximum {{max}})', {
              max: tag.range.max,
            });
          } else {
            tip += tag.range.max;
          }
        }
        return tip;
      case 'Decimal':
        tip = this.gettextCatalog.getString('Enter a number ');
        if (tag.range.min) {
          if (!tag.range.max) {
            tip += this.gettextCatalog.getString('(minimum {{min}})', {
              min: tag.range.min,
            });
          } else {
            tip += this.gettextCatalog.getString('from {{min}} to ', {
              min: tag.range.min,
            });
          }
        }
        if (tag.range.max) {
          if (!tag.range.min) {
            tip += this.gettextCatalog.getString('(maximum {{max}})', {
              max: tag.range.max,
            });
          } else {
            tip += tag.range.max;
          }
        }
        return tip;
      case 'Date':
        tip = this.gettextCatalog.getString('Select a date ');
        if (tag.range.min) {
          if (!tag.range.max) {
            tip += this.gettextCatalog.getString('({{min}} or later)', {
              min: moment(tag.range.min).format(this.dateFormatMoment),
            });
          } else {
            tip += this.gettextCatalog.getString('from {{min}} to ', {
              min: moment(tag.range.min).format(this.dateFormatMoment),
            });
          }
        }
        if (tag.range.max) {
          if (!tag.range.min) {
            tip += this.gettextCatalog.getString('({{max}} or earlier)', {
              max: moment(tag.range.max).format(this.dateFormatMoment),
            });
          } else {
            tip += moment(tag.range.max).format(this.dateFormatMoment);
          }
        }
        return tip;
      case 'Datetime':
        tip = this.gettextCatalog.getString('Select a date and time ');
        if (tag.range.min) {
          if (!tag.range.max) {
            tip += this.gettextCatalog.getString('({{min}} or later)', {
              min: moment(tag.range.min).format(this.dateTimeformat),
            });
          } else {
            tip += this.gettextCatalog.getString('from {{min}} to ', {
              min: moment(tag.range.min).format(this.dateTimeformat),
            });
          }
        }
        if (tag.range.max) {
          if (!tag.range.min) {
            tip += this.gettextCatalog.getString('({{max}} or earlier)', {
              max: moment(tag.range.max).format(this.dateTimeformat),
            });
          } else {
            tip += moment(tag.range.max).format(this.dateTimeformat);
          }
        }
        return tip;
    }
  }

  cancelClicked() {
    const equipmentID = this.equipmentData.id;
    if (equipmentID) {
      this.$state.go('equipment.detail', {
        equipmentId: equipmentID,
      });

      this.addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.cancelClicked,
      });
    }
  }

  saveClicked() {
    if (this.sending || this.detailForm.$invalid || !this.checkAllDatetimes()) {
      return;
    }

    this.sending = true;
    this.errorFlag = false;
    this.submitTags = [];
    this.equipToSubmit = cloneDeep(this.equipmentData);
    this.equipToSubmit.attrs = {};
    for (const key in this.parsedAttrs) {
      this.equipToSubmit.attrs[key] = this.parsedAttrs[key];
    }
    for (const k in this.protectedAttrs) {
      this.equipToSubmit.attrs[k] = this.protectedAttrs[k];
    }
    for (let i = 0; i < this.selectedTags.length; i++) {
      const selectedTag = this.selectedTags[i];
      const valueRecord = this.values[selectedTag.id];
      const toAdd = {
        key: selectedTag.key,
      };
      switch (selectedTag.dataType) {
        case 'Text':
        case 'Hyperlink':
        case 'Integer':
        case 'Decimal':
          toAdd.v = valueRecord.value;
          break;
        case 'Date':
          toAdd.v = this.$filter('date')(valueRecord.value, 'yyyy-MM-dd');
          break;
        case 'Datetime':
          if (typeof valueRecord.value === 'string') {
            toAdd.v = valueRecord.value;
          } else {
            let temp = moment(this.datetimedate[selectedTag.id].getTime()).toDate();
            if (valueRecord.value) {
              temp.setHours(valueRecord.value.getHours());
              temp.setMinutes(valueRecord.value.getMinutes());
              temp.setSeconds(valueRecord.value.getSeconds());
            }
            temp = moment(temp).toDate();
            temp.setMilliseconds(0);
            toAdd.v = temp;
          }
          break;
      }
      this.equipToSubmit.attrs[toAdd.key] = toAdd.v;
    }
    this.EquipmentService.putEquipment(this.equipToSubmit).then(
      (response) => {
        this.selectedTags = [];
        this.equipmentData = response.data;
        this.parseTags();
        this.isEditing = false;
        this.sending = false;
        this.$state.go('equipment.detail', {
          equipmentId: this.equipmentData.id,
        });
      },
      (error) => {
        let errorMsg = this.gettextCatalog.getString('An error occurred while updating the asset');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = `${
              error.data.message
            } ${error.status.toString()} - ${error.statusText.toString()}`;
          } else {
            errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
          }
        } else {
          errorMsg += this.gettextCatalog.getString('. Please try again later.');
        }
        this.errorFlag = true;
        this.errorText = errorMsg;
        this.sending = false;
      },
    );

    this.addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.saveClicked,
    });
  }

  refreshDetails() {
    this.timeout(() => {
      this.refresh();
    }, 300);
  }
}

export const EquipmentDetailEditComponent = {
  template,
  controller: EquipmentDetailEditController,
  controllerAs: 'vm',
  bindings: {},
};
